import request from "superagent";
import * as actionTypes from "Consts/index";

export const toggle = (show) => {
	return (dispatch) => {
		dispatch({
			type: actionTypes.MAIN_MENU__TOGGLE,
			payload: {
				show: !show,
			},
		});
	};
};
